'use strict';

angular.module('pulse')
  .filter('shortDate', ['$filter', function($filter) {
    return function(input) {
        return $filter('date')(input, 'MM/dd/yyyy');
    };
}]);
